<div class="body">
  <div class="container">
    <div class="row title-box">
      <div class="col-12 col-sm-12">
        <h3 class="txtbienvenida">Desbloquear <span class="txtbienvenida-2">Usuarios</span></h3>
      </div>
    </div>

    <form class="custom-form" [formGroup]="buscarUsuaForm">
      <div class="row justify-content-md-center mt-3">
        <div class="col-12 col-sm-12 col-md-3">
          <div class="mb-3 form-label">
            <label for="tipoDoc" class="form-label">Tipo de documento</label>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-4">
          <div class="mb-3 form-label">
            <select  class="form-control" formControlName="idTipoDocIdentidad_NeoTipoDocIdentidad" (change)="validarSelect()">
              <option [value]="null">Seleccione una opción</option>
              @for (documento of documentos; track documento) {
                <option [value]="documento.idTipoDocIdentidad">
                  {{ documento.nombre }}
                </option>
              }
            </select>
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-12 col-sm-12 col-md-3">
          <div class="mb-3 form-label">
            <label for="numDoc" class="form-label">Número de documento</label>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-4">
          <input type="text" class="form-control" minlength="5" maxlength="10" formControlName="numeroDocumento"
            (keypress)="validateDocument($event)" #input (input)="input.value=$event.target.value.toUpperCase()"/>
          </div>
        </div>
        <div class="row justify-content-md-center mt-3 g-3">
          <div class="col-12 col-md-2 container-btn">
            <button type="submit" id="btn-buscar" style="width: 180px;" (click)="trackBuscar(); botonBuscar()" class="btn btn-primary hvr-shrink">Buscar</button>
          </div>
          <div class="col-12 col-md-2 container-btn">
            <button class="btn btn-primary hvr-shrink" style="width: 180px;" routerLink="/intermediario/home">
              Volver
            </button>
          </div>
        </div>
      </form>
      @if (datosTabla) {
        <div class="row mt-4 pr-5 pl-5">
          <div class="table-responsive">
            <table class="table table-striped table-borderless rounded">
              <thead class="table_head">
                <tr>
                  <th scope="col" class="no-styles table-header" id="nombres">Nombre y Apellidos del Usuario</th>
                  <th scope="col" class="no-styles table-header" id="tipoDoc">Tipo de Documento</th>
                  <th scope="col" class="no-styles table-header" id="doc">Número de Documento</th>
                  <th scope="col" class="no-styles table-header" id="correo">Correo Electrónico</th>
                  <th scope="col" class="no-styles table-header" id="estado">Estado</th>
                  <th scope="col" class="no-styles table-header" id="accion">Desbloquear</th>
                </tr>
              </thead>
              <tbody>
                @for (usuario of listaUsuarios; track usuario; let i = $index) {
                  <tr>
                    <th scope="row">{{usuario.nombresYApellidos}}</th>
                    <td>{{usuario.tipoDocumento}}</td>
                    <td>{{usuario.numeroDocumento}}</td>
                    <td>{{usuario.correoElectronico}}</td>
                    <td>{{usuario.estado}}</td>
                    <td>
                      <button type="submit" id="btn-desbloquear" class="hvr-shrink" (click)="desbloquear(i)">
                        <i class="fas fa-unlock-alt"></i>
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
      @if (datosTabla) {
        <app-pagination (event)="selectPage($event)" [paginaActual]="paginaActual"
        [totalPaginas]="totalPaginas"></app-pagination>
      }
    </div>
    <!-- Modal -->
    <div class="modal fade text-center" id="desbloquearModal" tabindex="-1" aria-labelledby="desbloquearModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body justify-content-md-center">
            <div class="row">
              <div class="col-12 col-sm-12 me-3 ms-3">
                <h2>El usuario fue desbloqueado exitosamente</h2>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-md-center">
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="ngOnInit()">Aceptar</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade text-center" id="mensajeModal" tabindex="-1" aria-labelledby="mensajeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body justify-content-md-center">
            <div class="row">
              <div class="col-12 col-sm-12 me-3 ms-3">
                <h2>No se encontraron usuarios con los criterios seleccionados</h2>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-md-center">
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Aceptar</button>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-body"></div>
  </div>

